import { render, staticRenderFns } from "./PaymentReturn.vue?vue&type=template&id=66ad150c"
import script from "./PaymentReturn.vue?vue&type=script&lang=js"
export * from "./PaymentReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports